import React, { useEffect, useState } from "react";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import classes from "./index.module.css";
import { Link } from "react-router-dom";
import "../assets/css/index.css";
import { Badge, Button } from "@mui/material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../Redux/actions/user-actions";
import { getLanguagedataFunction } from "../utilities/language";
import {
  AddressBookIcon,
  ChatIcon,
  DemoIcon,
  HelpFaqIcon,
  HomeIcon,
  LocationIcon,
  MyTeamIcon,
  ReferEarnIcon,
  MapIcon,
  SubscriptionIcon,
} from "./Icons";
import report_icon from "../assets/images/report_icon.png";

const SideNavBar = () => {
  const dispatch = useDispatch();

  const [currentRoute, setCurrentRoute] = useState(
    window.location.pathname.toLowerCase(),
  );
  const togglesidebar = useSelector(
    (state) => state.allUsers.togglesidebar,
  );

  const ln = useSelector((state) => state.allUsers.language_json);
  const expensePendingCount = useSelector(
    (state) => state.allUsers.expensePendingCount,
  );

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln, dispatch]);

  useEffect(() => {
    if (ln) {
      dispatch(setHeaderName(ln.home));
    }
  }, [dispatch, ln]);

  const handleNavigate = (name, route) => {
    console.log(name, route);
    dispatch(setHeaderName(name));
    setCurrentRoute(route);
  };

  useEffect(() => {
    if (window.location.pathname.includes("my-profile")) {
      setCurrentRoute("home");
      return;
    }
    const path = window.location.pathname;
    const Arr = path.split("/");
    const name = Arr[Arr?.length - 1].toString();
    setCurrentRoute(name);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const menuItems = [
    { path: "/home", label: ln?.home, icon: <HomeIcon />, key: "home" },
    {
      path: "/location",
      label: ln?.locations,
      icon: <LocationIcon />,
      key: "location",
    },
    {
      path: "/my-team",
      label: ln?.my_team,
      icon: <MyTeamIcon />,
      key: "my-team",
    },
    { path: "/maps", label: ln?.map, icon: <MapIcon />, key: "maps" },
    { path: "/chat", label: ln?.chat, icon: <ChatIcon />, key: "chat" },
    {
      path: "/reports",
      label: "Reports",
      icon: (
        <img
          src={report_icon}
          width={24}
          style={{ marginRight: "8px" }}
          alt="Reports"
        />
      ),
      key: "reports",
    },
    {
      path: "/expense-approvals",
      label: ln?.expense_approvals || "Expense Approvals",
      icon: (
        <Badge
          badgeContent={expensePendingCount}
          color="error"
          max={99}
          sx={{ marginRight: "8px" }}
        >
          <ReceiptLongOutlinedIcon sx={{ color: "#0A1F41" }} />
        </Badge>
      ),
      key: "expense-approvals",
    },
    {
      path: "/address",
      // UI-only rename: the route, API and data are still "address book".
      label: ln?.customers || "Customers",
      icon: <AddressBookIcon />,
      key: "address",
    },
    {
      path: "/subscriptions",
      label: ln?.subscriptions,
      icon: <SubscriptionIcon />,
      key: "subscription",
    },
    {
      path: "/refer-earn",
      label: ln?.refer_earn,
      icon: <ReferEarnIcon />,
      key: "refer-earn",
    },
    {
      path: "/help-faq",
      label: ln?.help_faq,
      icon: <HelpFaqIcon />,
      key: "help-faq",
    },
    { path: "/demo", label: ln?.demo, icon: <DemoIcon />, key: "demo" },
  ];

  return (
    <div id="scrollbar">
      {ln ? (
        <div>
          <div
            className={classes.nabBarContainer}
            style={{ height: window.outerHeight, minHeight: "750px" }}
          >
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={
                  currentRoute.includes(item.key) ? `${classes.activebtn}` : ""
                }
                onClick={() => handleNavigate(item.label, item.path)}
              >
                <li className={togglesidebar ? classes.sideNaveBarli : ""}>
                  <Button variant="text" className={classes.linkburron}>
                    {item.icon} {togglesidebar ? item.label : null}
                  </Button>
                </li>
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SideNavBar;
